import React from 'react';

import classNames from 'classnames';

import { TbStar } from 'react-icons/tb';

import Icon from 'components-new/icon/icon';

interface RatingStarsPropTypes {
  rating: number;
  maxRating: number;
  className?: string;
}

type ratingData = {
  filled: boolean;
  id: number;
};

const RatingStars: React.FC<RatingStarsPropTypes> = (props) => {
  const { rating, maxRating, className } = props;
  const containerClassName = classNames(
    'h-6 mt-1 mb-2 flex items-start justify-start hidden',
    className,
  );

  const ratingList: ratingData[] = [];
  for (let i = 1; i <= maxRating; i += 1) {
    ratingList.push({ filled: i <= rating, id: i });
  }
  const perc = (rating % 1) * 100;

  return (
    <div className={containerClassName}>
      {ratingList.map((value, index) => {
        if (value.filled)
          return (
            <Icon
              key={value.id}
              icon={TbStar}
              className={classNames(
                'relative  bg-white',
                'mr-1',
                value.filled && 'text-[#FFE64E]',
              )}
              fill="#FFE64E"
              color="#FFE64E"
            />
          );

        if (!value.filled && rating - index > 0 && rating - index < 1) {
          return (
            <svg
              key={value.id}
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="bg-white mr-1 text-[#FFE64E]"
              color="#FFE64E"
              height="24"
              width="24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <defs>
                <linearGradient id="partial_grad">
                  <stop offset={`${perc}%`} stopColor="#FFE64E" />
                  <stop offset={`${perc}%`} stopColor="white" stopOpacity="1" />
                </linearGradient>
              </defs>

              <path stroke="none" d="M0 0h24v24H0z" fill="white" />
              <path
                fill="url(#partial_grad)"
                d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z"
              />
            </svg>
          );
        }

        return (
          <Icon
            key={value.id}
            icon={TbStar}
            className={classNames('mr-1', 'text-gray-300')}
            fill="white"
            color="gray-300"
          />
        );
      })}
    </div>
  );
};

export default RatingStars;
